<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <!-- 发送者姓名搜索 -->
          <el-input v-model="formDatas.senderNick" placeholder="发送者姓名" size="mini" clearable
            style="width: 120px; margin-left: 10px" @keyup.enter.native="partserch">
          </el-input>
          <!-- 处理状态筛选 -->
          <el-select v-model="formDatas.asdmStatus" placeholder="处理状态" size="mini" clearable
            style="width: 120px; margin-left: 10px" @change="partserch">
            <el-option label="待处理" :value="1"></el-option>
            <el-option label="已处理" :value="2"></el-option>
          </el-select>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
            :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
            :cell-style-option="cellStyleOption" row-key-field-name="asdmId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
            :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
            @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getAjSalaryDingtalkMessageList, updateAjSalaryDingtalkMessageHandler } from "../../api/api";
export default {
  name: "dingtalkMessage",
  components: {},
  data() {
    return {
      windheight: "",
      tableHight: 520,
      totalCount: 0,
      watchFlag: false,
      // 表头样式
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      // 表格列配置
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          fixed: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex + (this.formDatas.currentPage - 1) * this.formDatas.pageSize;
          },
        },
        {
          field: "conversationType",
          key: "conversationType",
          title: "会话类型",
          align: "center",
          width: 90,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.conversationType == 1 ? '单聊' : '群聊';
          },
        },
        {
          field: "msgtype",
          key: "msgtype",
          title: "消息类型",
          align: "center",
          width: 100,
        },
        {
          field: "senderNick",
          key: "senderNick",
          title: "发送者昵称",
          align: "center",
          width: 150,
        },
        {
          field: "senderStaffId",
          key: "senderStaffId",
          title: "发送者员工ID",
          align: "center",
          width: 190,
        },
        {
          field: "msgStr",
          key: "msgStr",
          title: "消息文本",
          align: "center",
          width: 420,
        },
        {
          field: "createtime",
          key: "createtime",
          title: "记录创建时间",
          align: "center",
          width: 150,
        },
        {
          field: "asdmStatus",
          key: "asdmStatus",
          title: "状态",
          align: "center",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.asdmStatus === 1 ? <el-tag size="mini" type="warning">待处理</el-tag> :
                    row.asdmStatus === 2 ? <el-tag size="mini" type="success">已处理</el-tag> :
                      <el-tag size="mini" type="info">未知</el-tag>
                }
              </span>
            );
          },
        },
        // 操作列
        {
          field: "",
          key: "d",
          title: "操作",
          width: 120,
          fixed: "right",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.asdmStatus === 1 ? (
                    <el-button
                      size="mini"
                      type="text"
                      style="color: #E6A23C"
                      on-click={() => this.handleProcess(row)}
                    >
                      处理
                    </el-button>
                  ) : ''
                }
              </span>
            );
          },
        },
      ],
      tableData: [],
      // 查询参数
      formDatas: {
        senderNick: '',
        asdmStatus: null,
        currentPage: 1,
        pageSize: 20,
      },
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    this.getList();
  },
  mounted() { },
  methods: {
    // 获取列表数据
    getList() {
      getAjSalaryDingtalkMessageList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
      });
    },
    // 搜索（重置到第一页）
    partserch() {
      this.formDatas.currentPage = 1;
      getAjSalaryDingtalkMessageList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
      });
    },
    // 处理消息
    handleProcess(row) {
      this.$confirm("是否确定要处理吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateAjSalaryDingtalkMessageHandler({ asdmId: row.asdmId }).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "处理成功!",
              });
              this.partserch();
            }
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 页码变化
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      getAjSalaryDingtalkMessageList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
      });
    },
    // 每页条数变化
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.partserch();
    },
  },
};
</script>

<style>
.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
  display: none;
}

.ve-table-container {
  height: auto !important;
}
</style>
